(function () {
  'use strict';

  var widget = document.getElementById('looxReviews');
  if (!widget) return;

  var header = document.getElementById('sl-loox-header');
  var grid = document.getElementById('grid');
  var distPanel = widget.querySelector('.reviews-dist');
  var distContent = widget.querySelector('.review-dist-content');
  var summaryBtn = widget.querySelector('.summary-content');
  var sortMenu = widget.querySelector('.sl-loox__sort-menu');
  var menuBtn = document.getElementById('menu-btn');
  var lightbox = document.querySelector('[data-loox-lightbox]');
  var productTitle = widget.dataset.productTitle || 'product';
  var imgBase = widget.dataset.looxImgBase || '';

  function reviewImageSrc(review) {
    var img = review.image;
    if (!img) {
      if (review.images && review.images.length) {
        var legacy = review.images[0];
        if (legacy.indexOf('http') === 0) return legacy;
        return imgBase + legacy;
      }
      return null;
    }
    if (typeof img === 'string') {
      if (img.indexOf('http') === 0) return img;
      return imgBase + img;
    }
    if (img.file) return imgBase + img.file;
    if (img.src) return img.src;
    return null;
  }

  function reviewImageRatio(review) {
    if (review.image && review.image.ratio) return review.image.ratio;
    return 1.33;
  }

  function reviewImageBg(review) {
    if (review.image && review.image.bg) return review.image.bg;
    return '';
  }

  var state = {
    data: null,
    sort: 'featured',
    filterRating: null,
    reviews: [],
    originalOrder: []
  };

  function escapeHtml(text) {
    var el = document.createElement('div');
    el.textContent = text == null ? '' : String(text);
    return el.innerHTML;
  }

  function parseDate(str) {
    var parts = String(str || '').split('/').map(Number);
    if (parts.length < 3 || !parts[0]) return 0;
    return new Date(parts[0], parts[1] - 1, parts[2]).getTime();
  }

  function starSvg(fill, size) {
    var sz = size || '1em';
    return (
      '<svg viewBox="0 0 24 24" data-lx-fill="' +
      fill +
      '" class="loox-icon star" style="display:block;width:' +
      sz +
      ';height:' +
      sz +
      '"><use href="#sl-loox-star"></use></svg>'
    );
  }

  function starsRow(rating, size) {
    var html =
      '<span style="display:inline-flex;margin:unset;padding:unset;gap:2px" role="img" aria-label="Rating icons: ' +
      rating +
      ' / 5 star review">';
    for (var i = 1; i <= 5; i++) {
      html += starSvg(i <= rating ? 'full' : 'empty', size);
    }
    html += '</span>';
    return html;
  }

  function verifiedBadge() {
    return (
      '<span class="verified-badge-and-text">' +
      '<svg viewBox="0 0 24 24" aria-label="Verified purchase" role="img" class="loox-icon loox-verified-badge">' +
      '<use href="#sl-loox-verified"></use></svg></span>'
    );
  }

  function renderReviewCard(review) {
    var wrapCls = review.has_image ? 'has-img' : 'no-img';
    var imgHtml = '';
    var imgSrc = reviewImageSrc(review);
    if (review.has_image && imgSrc) {
      var alt = 'Customer photo review of ' + productTitle;
      var ratioPct = (reviewImageRatio(review) * 100).toFixed(2) + '%';
      var bg = reviewImageBg(review);
      var bgStyle = bg ? ' style="background:' + bg + ';"' : '';
      imgHtml =
        '<div class="item-img box"><div class="image-aspect-ratio-wrapper">' +
        '<div class="image-aspect-ratio" style="padding-bottom:' +
        ratioPct +
        '"></div>' +
        '<img src="' +
        escapeHtml(imgSrc) +
        '" alt="' +
        escapeHtml(alt) +
        '" loading="lazy" class="action" data-loox-img' +
        bgStyle +
        '></div></div>';
    }

    var meta = '';
    if (review.item_type) {
      meta =
        '<div style="margin-top:8px" class="block"><div class="metadata">' +
        '<div class="small text-muted">Item type:</div>' +
        '<div class="value">' +
        escapeHtml(review.item_type) +
        '</div></div></div>';
    }

    return (
      '<div class="grid-item-wrap ' +
      wrapCls +
      '" data-id="' +
      escapeHtml(review.id) +
      '" data-rating="' +
      review.rating +
      '">' +
      '<div tabindex="0" role="button" class="grid-item clearfix">' +
      imgHtml +
      '<div class="main action"><div class="box trimmed-text">' +
      '<div class="block title">' +
      escapeHtml(review.name) +
      (review.verified ? verifiedBadge() : '') +
      '</div><div class="clearfix"></div>' +
      '<div class="block time">' +
      escapeHtml(review.date) +
      '</div>' +
      '<div class="block stars">' +
      starsRow(review.rating) +
      '</div>' +
      '<div class="block"><div class="pre-wrap main-text">' +
      escapeHtml(review.text) +
      '</div></div>' +
      meta +
      '</div></div></div></div>'
    );
  }

  function renderHeaderSummary(data) {
    var avgEl = widget.querySelector('[data-testid="rating-summary-avg"]');
    var countEl = widget.querySelector('.sl-loox__count-label');
    if (avgEl) {
      avgEl.setAttribute('aria-label', 'Average rating: ' + data.average + ' / 5 star review');
      avgEl.innerHTML = starsRow(Math.round(data.average), '24px');
      avgEl.style.marginRight = '10px';
      avgEl.style.display = 'inline-flex';
      avgEl.style.alignItems = 'center';
    }
    if (countEl) countEl.textContent = data.count + ' Reviews';
  }

  function renderDistribution(data) {
    if (!distContent) return;
    var total = data.count || 0;
    var rows = '';
    for (var star = 5; star >= 1; star--) {
      var count = (data.distribution && data.distribution[String(star)]) || 0;
      var width = total ? (count / total) * 100 : 0;
      var disabled = count === 0 ? ' no-reviews' : '';
      var pressed = state.filterRating === star ? ' aria-pressed="true"' : ' aria-pressed="false"';
      rows +=
        '<tr data-rating="' +
        star +
        '" class="rating-dist-row' +
        disabled +
        '" role="button" aria-label="Filter by ' +
        star +
        ' stars, ' +
        count +
        ' reviews"' +
        pressed +
        (count === 0 ? ' aria-disabled="true"' : '') +
        '>' +
        '<td style="padding-left:4px" aria-hidden="true"><div>' +
        starsRow(star, '18px') +
        '</div></td>' +
        '<td style="padding:6px 10px;width:100%" aria-hidden="true">' +
        '<div class="loox-progress"><div class="loox-progress-value" style="width:' +
        width +
        '%"></div></div></td>' +
        '<td class="reviews-num" style="padding-right:4px" aria-hidden="true">(' +
        count +
        ')</td></tr>';
    }

    distContent.innerHTML =
      '<span style="gap:12px;font-size:32px" aria-label="Average rating: ' +
      data.average +
      ' / 5 star review" tabindex="0" role="figure">' +
      starSvg('full', '32px') +
      data.average +
      '</span>' +
      '<div role="region" aria-label="Rating distribution - filter reviews by star rating" tabindex="0" class="progress-section">' +
      '<table style="border-spacing:0 6px"><tbody>' +
      rows +
      '</tbody></table></div>';
  }

  function sortReviews(reviews) {
    var list = reviews.slice();
    if (state.sort === 'newest') {
      list.sort(function (a, b) {
        return parseDate(b.date) - parseDate(a.date);
      });
    } else if (state.sort === 'highest_ratings') {
      list.sort(function (a, b) {
        return b.rating - a.rating || parseDate(b.date) - parseDate(a.date);
      });
    } else if (state.sort === 'lowest_ratings') {
      list.sort(function (a, b) {
        return a.rating - b.rating || parseDate(b.date) - parseDate(a.date);
      });
    } else {
      var order = {};
      state.originalOrder.forEach(function (id, idx) {
        order[id] = idx;
      });
      list.sort(function (a, b) {
        return (order[a.id] || 0) - (order[b.id] || 0);
      });
    }
    return list;
  }

  function getFilteredReviews() {
    var list = state.data.reviews || [];
    if (state.filterRating) {
      list = list.filter(function (r) {
        return r.rating === state.filterRating;
      });
    }
    return sortReviews(list);
  }

  function getColumnCount(width) {
    if (width >= 1380) return 6;
    if (width >= 1150) return 5;
    if (width >= 920) return 4;
    if (width >= 480) return 3;
    if (width >= 320) return 2;
    return 1;
  }

  function layoutMasonry() {
    if (!grid) return;
    var items = grid.querySelectorAll('.grid-item-wrap');
    if (!items.length) {
      grid.style.height = '0px';
      return;
    }

    var cols = getColumnCount(grid.offsetWidth);
    var gap = 14;
    var colWidth = grid.offsetWidth / cols;
    var colHeights = new Array(cols).fill(0);

    items.forEach(function (item) {
      item.style.position = 'absolute';
      item.style.width = colWidth + 'px';
      var minCol = 0;
      for (var c = 1; c < cols; c++) {
        if (colHeights[c] < colHeights[minCol]) minCol = c;
      }
      item.style.left = minCol * colWidth + 'px';
      item.style.top = colHeights[minCol] + 'px';
      colHeights[minCol] += item.offsetHeight + gap;
    });

    grid.style.height = Math.max.apply(null, colHeights) + 'px';
  }

  function renderGrid() {
    var reviews = getFilteredReviews();
    grid.innerHTML = reviews.map(renderReviewCard).join('');
    grid.classList.add('grid-active');
    requestAnimationFrame(function () {
      layoutMasonry();
      bindImageClicks();
    });
  }

  function bindImageClicks() {
    grid.querySelectorAll('[data-loox-img]').forEach(function (img) {
      img.addEventListener('load', layoutMasonry);
      img.addEventListener('click', function (e) {
        e.stopPropagation();
        if (!lightbox) return;
        lightbox.querySelector('img').src = img.src;
        lightbox.hidden = false;
        document.body.style.overflow = 'hidden';
      });
    });
  }

  function closeDropdowns(except) {
    [distPanel, sortMenu].forEach(function (panel) {
      if (!panel || panel === except) return;
      panel.classList.remove('shown');
    });
    if (summaryBtn && except !== distPanel) {
      summaryBtn.setAttribute('aria-expanded', 'false');
      var chevOpen = widget.querySelector('.chevron-open');
      var chevClosed = widget.querySelector('.chevron-closed');
      if (chevOpen) chevOpen.classList.remove('chevron-hide');
      if (chevClosed) chevClosed.classList.add('chevron-hide');
    }
    if (menuBtn && except !== sortMenu) menuBtn.setAttribute('aria-expanded', 'false');
  }

  function togglePanel(panel, trigger) {
    var open = !panel.classList.contains('shown');
    closeDropdowns(open ? panel : null);
    panel.classList.toggle('shown', open);
    if (trigger) trigger.setAttribute('aria-expanded', open ? 'true' : 'false');
    if (panel === distPanel) {
      var openChev = widget.querySelector('.chevron-open');
      var closedChev = widget.querySelector('.chevron-closed');
      if (openChev) openChev.classList.toggle('chevron-hide', open);
      if (closedChev) closedChev.classList.toggle('chevron-hide', !open);
    }
  }

  function updateSortUI() {
    sortMenu.querySelectorAll('button[data-sort]').forEach(function (btn) {
      var active = btn.dataset.sort === state.sort;
      btn.setAttribute('aria-pressed', active ? 'true' : 'false');
      var mark = btn.querySelector('span');
      if (mark) mark.classList.toggle('chosen-option', active);
    });
  }

  function bindEvents() {
    if (summaryBtn && distPanel) {
      summaryBtn.addEventListener('click', function () {
        togglePanel(distPanel, summaryBtn);
      });
    }

    if (menuBtn && sortMenu) {
      menuBtn.addEventListener('click', function (e) {
        e.stopPropagation();
        togglePanel(sortMenu, menuBtn);
      });
    }

    sortMenu.querySelectorAll('button[data-sort]').forEach(function (btn) {
      btn.addEventListener('click', function () {
        state.sort = btn.dataset.sort;
        updateSortUI();
        closeDropdowns();
        renderGrid();
      });
    });

    if (distContent) {
      distContent.addEventListener('click', function (e) {
        var row = e.target.closest('.rating-dist-row');
        if (!row || row.classList.contains('no-reviews')) return;
        var rating = Number(row.dataset.rating);
        state.filterRating = state.filterRating === rating ? null : rating;
        renderDistribution(state.data);
        renderGrid();
      });
    }

    document.addEventListener('click', function (e) {
      if (!widget.contains(e.target)) closeDropdowns();
    });

    if (lightbox) {
      lightbox.addEventListener('click', function () {
        lightbox.hidden = true;
        document.body.style.overflow = '';
      });
      lightbox.querySelector('.sl-loox-lightbox__close').addEventListener('click', function (e) {
        e.stopPropagation();
        lightbox.hidden = true;
        document.body.style.overflow = '';
      });
    }

    var resizeTimer;
    window.addEventListener('resize', function () {
      clearTimeout(resizeTimer);
      resizeTimer = setTimeout(layoutMasonry, 120);
    });
  }

  function init(data) {
    state.data = data;
    state.originalOrder = (data.reviews || []).map(function (r) {
      return r.id;
    });
    state.reviews = data.reviews || [];

    if (data.star_color) {
      widget.style.setProperty('--sl-loox-star', data.star_color);
    }

    renderHeaderSummary(data);
    renderDistribution(data);
    renderGrid();
    header.hidden = false;
    widget.classList.add('sl-loox--ready');
    bindEvents();
  }

  fetch(widget.dataset.reviewsUrl)
    .then(function (res) {
      return res.json();
    })
    .then(init)
    .catch(function () {
      if (header) header.hidden = true;
      if (grid) grid.innerHTML = '<p class="sl-loox__error">Unable to load reviews.</p>';
    });
})();
